export default __webpack_public_path__ + "static/media/NOTO_SANS_TC_600.083d7f1b.ttf";